export default "__VITE_ASSET__CvHRdyVJ__"